<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-8"><a id="_idTextAnchor008"></a>Absent Wells</h2>
<p class="Verse-new">Not in broken</p>
<p class="Verse-main">fragments</p>
<p class="Verse-main">of head-birth gods </p>
<p class="Verse-main">temping as the real thing</p>
<p class="Verse-main">nor tamed </p>
<p class="Verse-main">box-brain infobees</p>
<p class="Verse-main">buzzing loudly</p>
<p class="Verse-main">in the head,</p>
<p class="Verse-new">but,</p>
<p class="Verse-new">the singing beauty</p>
<p class="Verse-main">of a world set free</p>
<p class="Verse-main">sagas of the rending heart</p>
<p class="Verse-main">laments like tears falling</p>
<p class="Verse-main">on dried ashes of the soul</p>
<p class="Verse-main">wounded cries embracing </p>
<p class="Verse-main">the teeming fount</p>
<p class="Verse-main">of present loves</p>
<p class="Verse-main">and breeding grounds</p>
<p class="Verse-main">of hope.</p>
<p class="Verse-new">Such roots</p>
<p class="Verse-last">struck in fertile ground</p>
<p class="Verse-last">grow like trees of life</p>
<p class="Verse-last">fruit-laden, green leaves</p>
<p class="Verse-last">fed and watered, circled</p>
<p class="Verse-last">by the dark aura</p>
<p class="Verse-last">of the light-clad mystery</p>
<p class="Verse-last">of our ever-present</p>
<p class="Verse-last">absent God.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-10.vue?c401d956